import { render, staticRenderFns } from "./viewMappingList.vue?vue&type=template&id=5caaac57&scoped=true"
import script from "./viewMappingList.vue?vue&type=script&lang=js"
export * from "./viewMappingList.vue?vue&type=script&lang=js"
import style0 from "./viewMappingList.vue?vue&type=style&index=0&id=5caaac57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caaac57",
  null
  
)

export default component.exports